import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDate, limitParagraphByCharLimit } from "../../Helper/Helper";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import Spinner from "../Spinner";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function BlogsGrid() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("blogs/list");
      setBlogsData(response?.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Blogs" Image="theme-2-banner-blog.webp" />

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <Spinner />
          </div>
        ) : blogsData?.length > 0 ? (
          <section className="blog-section pad-top-80 pad-bottom-80 full-dark">
            <div className="container">
              {/* <div className="row">
                <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title mb-0 text-uppercase">
                        Our Latest <span className="theme-color">Blogs</span>
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="row">
                {blogsData?.map((data, index) => (
                  <div className="col-md-4 mb-4" key={index}>
                    <div className="blog-main-wrapper blog-style-1">
                      <div className="blog-inner" style={{ height: "480px" }}>
                        <div className="blog-thumb relative">
                          <img
                            src={data?.image}
                            className="img-fluid"
                            style={{ height: "auto", width: "100%" }}
                            alt="blog-img"
                          />
                          <div className="top-meta">
                            <ul className="top-meta-list">
                              <li>
                                <div className="post-date">
                                  <a className="side-img-news-date">
                                    <i className="ti-calendar theme-color me-1"></i>
                                    {formatDate(data?.date)}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="blog-details pt-0">
                          <div className="blog-title">
                            <h4 className="margin-bottom-10" style={{}}>
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="blog-name"
                              >
                                {limitParagraphByCharLimit(data?.title, 50) +
                                  (data?.title?.length > 50 ? "..." : "")}
                              </Link>
                            </h4>
                          </div>
                          <div className="post-desc mt-2">
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  limitParagraphByCharLimit(data?.short_content, 75) +
                                  (data?.short_content?.length > 75 ? "..." : ""),
                              }}

                            />
                            <div className="blog-link stacked-home-news-readmore">
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="link font-w-500"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        ) : (
          <div className="col-12 text-center my-5 py-5">
            <h4>No Record Available</h4>
          </div>
        )}

        <FooterWrapper />
      </div>
    </div>
  );
}

export default BlogsGrid;